import React from "react";
import { components } from "react-select";
import PopOver from "../global/PopOver";

const SelectOptionWithInfo = (props) => {
    const { label, data } = props;

    return (
        <components.Option {...props}>
            <div className="d-flex align-items-center justify-content-between w-100">
                <span>{label}</span>
                {data?.info && (
                    <PopOver
                        title={data.info}
                        customStyle={{
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            padding: "0",
                            marginLeft: "8px",
                            fontSize: "11px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        className="ml-2"
                    />
                )}
            </div>
        </components.Option>
    );
};

export default SelectOptionWithInfo;
